export const normalizePoem = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z]/g, '');

export function mapLinks(airport) {
  if (!airport || !Number.isFinite(airport.lat) || !Number.isFinite(airport.lon)) return null;
  const { lat, lon } = airport;
  const params = new URLSearchParams({
    center: `${lat},${lon}`, zoom: '6', size: '600x400', maptype: 'roadmap',
    markers: `color:red|${lat},${lon}`,
  });
  return {
    image: `/.netlify/functions/maps?${params}`,
    full: `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`,
  };
}

export function bubblePosition(anchor, width, height, viewportWidth, viewportHeight) {
  const margin = 10;
  const left = Math.max(margin, Math.min(anchor.left + (anchor.width - width) / 2, viewportWidth - width - margin));
  const below = anchor.bottom + margin;
  const preferredTop = below + height <= viewportHeight - margin ? below : anchor.top - height - margin;
  const top = Math.max(margin, Math.min(preferredTop, viewportHeight - height - margin));
  return { left, top };
}
